import { createContext, useContext } from 'react'

const EsignatureF0Context = createContext(false)

export const EsignatureF0Provider = EsignatureF0Context.Provider

export const useEsignatureF0 = () => useContext(EsignatureF0Context)
